var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProductListIcon = function SvgProductListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_list_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A8ACB5",
    d: "M19.484 5.176 15.558.196A.51.51 0 0 0 15.156 0H4.847a.51.51 0 0 0-.402.197L.52 5.176a.5.5 0 0 0-.112.316v13.994c0 .283.231.514.514.514h18.155a.515.515 0 0 0 .514-.514V5.492a.47.47 0 0 0-.108-.316m-1.396-.112h-7.573V1.027h4.392zM5.096 1.027h4.392v4.037H1.915zm-3.66 17.946V6.092h17.127v12.88z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "product_list_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgProductListIcon;